<template>
  <div class="c-wysiwyg">

    <template v-for="(module, i) in modules">
      <!--
      *
      * 見出し
      *
      -->
      <scroll-animation-unit>
        <h3 
          v-if="module.acf_fc_layout === 'module_heading'" 
          class="c-wysiwyg__heading u-fade">
          {{ module.text }}
        </h3>
      </scroll-animation-unit>


      <!--
      *
      * p, b, i,
      *
      -->
      <scroll-animation-unit>
        <div 
          v-if="module.acf_fc_layout === 'module_text'" 
          class="c-wysiwyg__text u-fade">
          <div v-whtml="module.text"></div>
        </div>
      </scroll-animation-unit>


      <!--
      *
      * 画像
      *
      -->
      <scroll-animation-unit>
        <figure 
          v-if="module.acf_fc_layout === 'module_image'"　
          class="c-wysiwyg__image u-fade">
          <img :src="module.image.url" :alt="module.image.alt" class="u-cover">
          <figcaption v-if="module.caption" v-html="module.caption"></figcaption>
        </figure>
      </scroll-animation-unit>


      <!--
      *
      * 2カラム画像
      *
      -->
      <scroll-animation-unit>
        <ul 
          v-if="module.acf_fc_layout === 'module_image_col2'"　
          class="c-wysiwyg__imageCol2">
          <li 
            v-for="(item, i) in module.image_col" 
            class="u-fade"
            :style="{
              'transition-delay': `${i / 10}s`
            }">
            <figure class="c-wysiwyg__figure">
              <img :src="item.image.url" :alt="item.image.alt" class="u-cover">
              <figcaption v-if="item.caption" v-html="item.caption"></figcaption>
            </figure>
          </li>
        </ul>
      </scroll-animation-unit>


      <!--
      *
      * 画像つきテキスト
      *
      -->
      <scroll-animation-unit 
        v-if="module.acf_fc_layout === 'module_image_text'"　
        class="c-wysiwyg__imageText">
        <div v-html="module.text" class="u-fade"></div>
        <figure class="u-fade">
          <img :src="module.image.url" :alt="module.image.alt" class="u-cover">
          <figcaption v-if="module.caption" v-text="module.caption"></figcaption>
        </figure>
      </scroll-animation-unit>
    </template>
  </div><!-- /.c-wysiwyg -->
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'global-wysiwyg',
    props: {
      post: {
        type: Object,
        default() {
          return {
            acf: {},
            date: '',
            id: '',
            slug: '',
            title: ''
          }
        }
      }
    },
    data() {
      return {
        modules: [],
        module: {
          acf_fc_layout: '',
          item: {},
          table: {},
          image: {}
        }
      }
    },
    watch: {
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.modules = this.post.acf.modules;
      },
      onChangeViewer() {
        // this.$children[0].$forceUpdate();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/global-wysiwyg.vue